/* eslint-disable camelcase */
module.exports = function getResource(label, vars = []) {
    const resources = {
        selectAllThatApply: 'Select all that apply',
        clear: 'Clear',
        apply: 'Apply',
        noResults: 'No Results.',
        notSure: 'Not sure',
        noPreference: 'No Preference',
        // ingredients
        aha_glycolic_acid: 'AHA/Glycolic Acid',
        alcoholFree: 'Alcohol Free',
        antioxidants: 'Antioxidants',
        benzoyl_peroxide: 'Benzoyl Peroxide',
        cbd: 'CBD',
        cleanAtSephora: 'Clean at Sephora',
        cleanPlanetPositive: 'Clean Planet Positive',
        crueltyFree: 'Cruelty-Free',
        fragrance_free: 'Fragrance Free',
        hyaluronic_acid: 'Hyaluronic Acid',
        hydroquinone: 'Hydroquinone',
        mineral: 'Mineral',
        mineralPhysical: 'Mineral Physical',
        naturallyDerived: 'Naturally Derived',
        niacinamide: 'Niacinamide',
        oil_free: 'Oil-free',
        organic: 'Organic',
        paraben_free: 'Paraben-free',
        peptides: 'Peptides',
        retinoid: 'Retinoid',
        salicylicAcid: 'Salicylic Acid',
        siliconeFree: 'Silicone Free',
        squalane: 'Squalane',
        sulfate_free: 'Sulfate-free',
        sulfur: 'Sulfur',
        vegan: 'Vegan',
        vitamin_c: 'Vitamin C',
        // brands
        yvesSaintLaurent: 'Yves Saint Laurent',
        sephoraCollection: 'SEPHORA COLLECTION',
        marcJacobsBeauty: 'Marc Jacobs Beauty',
        charlotteTilbury: 'Charlotte Tilbury',
        givenchy: 'Givenchy',
        tomFord: 'TOM FORD',
        kvdBeauty: 'KVD Beauty',
        dior: 'Dior',
        nars: 'NARS',
        hudaBeauty: 'HUDA BEAUTY',
        hourglass: 'Hourglass',
        armaniBeauty: 'Armani Beauty',
        patMcgrathLabs: 'PAT McGRATH LABS',
        gucci: 'Gucci',
        bobbiBrown: 'Bobbi Brown',
        clinique: 'CLINIQUE',
        tarte: 'tarte',
        nudeStix: 'NUDESTIX',
        lancome: 'Lancôme',
        guerlain: 'GUERLAIN',
        fentyBeautyByRihanna: 'Fenty Beauty by Rihanna',
        urbanDecay: 'Urban Decay',
        makeUpForEver: 'MAKE UP FOR EVER',
        ciateLondon: 'Ciaté London',
        anastasiaBeverlyHills: 'Anastasia Beverly Hills',
        tooFaced: 'Too Faced',
        smashbox: 'Smashbox',
        biteBeauty: 'Bite Beauty',
        valentino: 'Valentino',
        shiseido: 'Shiseido',
        rmsBeauty: 'rms beauty',
        natashaDenona: 'Natasha Denona',
        milkMakeup: 'MILK MAKEUP',
        lauraMercier: 'Laura Mercier',
        kaja: 'Kaja',
        jouerCosmetics: 'Jouer Cosmetics',
        ilia: 'ILIA',
        christianLouboutin: 'Christian Louboutin',
        wanderBeauty: 'Wander Beauty',
        sephoraFavorites: 'Sephora Favorites',
        patrickTa: 'PATRICK TA',
        meltCosmetics: 'Melt Cosmetics',
        makeupByMario: 'MAKEUP BY MARIO',
        lilahB: 'lilah b.',
        lawless: 'LAWLESS',
        kilianParis: 'KILIAN Paris',
        danessaMyricksBeauty: 'Danessa Myricks Beauty',
        bareMinerals: 'bareMinerals',
        artistCouture: 'Artist Couture',
        westmanAtelier: 'Westman Atelier',
        stila: 'stila',
        roseInc: 'ROSE INC',
        rareBeautyBySelenaGomez: 'Rare Beauty by Selena Gomez',
        perriconeMd: 'Perricone MD',
        kosas: 'Kosas',
        kiehlsSince1851: 'Kiehl\'s Since 1851',
        josieMaran: 'Josie Maran',
        itCosmetics: 'IT Cosmetics',
        inCredible: 'INC.redible',
        freckBeauty: 'Freck Beauty',
        fashionFair: 'Fashion Fair',
        esteeLauder: 'Estée Lauder',
        dominiqueCosmetics: 'DOMINIQUE COSMETICS',
        buxom: 'Buxom',
        benefitCosmetics: 'Benefit Cosmetics',
        athrBeauty: 'Athr Beauty'
    };

    return resources[label];
};
